
import { Component, Prop, Vue } from 'vue-property-decorator';

import { getStockCheckHistory } from '@/api/stock';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'StockCheckRecordChildrenList'
})
export default class extends Vue {
  // 当前层级的名称列表
  @Prop({
    type: Array,
    default: () => []
  })
  list!: any[];

  // 当前列表的父级库存 id
  @Prop({
    type: [String, Number],
    default: ''
  })
  pid!: any;

  // 盘点时间（历史快照标识，懒加载下级时需一并传入以保证同一次盘点）
  @Prop({
    type: [String, Number],
    default: ''
  })
  datatime!: any;

  // 展开行：懒加载下级名称（盘点记录接口传 stock_pid 获取）
  private handleExpandChange(row: any, expandedRows: any[]) {
    const expanded = expandedRows.some((item: any) => item.stock_id === row.stock_id);
    if (expanded && !row.childrenx) {
      this.fetchChildren(row);
    }
  }

  private fetchChildren(row: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      stock_pid: row.stock_id,
      page: 1,
      size: 9999
    };
    if (this.datatime) {
      params.datatime = this.datatime;
    }
    getStockCheckHistory(params)
      .then((res: any) => {
        const data = res.data;
        this.$set(row, 'childrenx', data && data.list ? data.list : []);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  private large(val: any) {
    let arr = [val];
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: 1
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
}
